<ng-container *ngIf="config?.skipAclCheck || (menuGuards && (menuGuards[config?.id] | async))">
  @if(config.route){
    <a tabIndex="0" routerLink="{{ config.route }}" routerLinkActive="active" class="link"
    [routerLinkActiveOptions]="{ exact: true }" (click)="triggerSubMenu($event, 'routerNavigate')">
    <div class="gms-container" [id]="config.id">
      <i class="{{ config.icon }} item-icon"></i>
      <span class="shrink label">
          {{ config.label }}
      </span>
      <ng-content></ng-content>
    </div>
  </a>
  }

  @if(config.href){
    <a href="{{ config.href }}" tabIndex="0" class="link" target="_blank">
      <div class="gms-container" [id]="config.id">
        <i class="{{ config.icon }} item-icon"></i>
        <span class="shrink label">
          {{ config.label }}
        </span>
        <ng-content></ng-content>
      </div>
    </a>
  }

  @if(!config.route && !config.href){
    <div class="link gms-container" [id]="config.id" tabIndex="0" [ngClass]="{
      active: (activePrimaryNavMenuId$ | async) === config.id,
      selected: (selectedPrimaryNavConfig$ | async)?.id === config.id
    }" (click)="triggerSubMenu($event)" (keydown.ArrowRight)="triggerSubMenu($event)"
    (keydown.ArrowLeft)="triggerSubMenu(null)">
    <i class="{{ config.icon }} item-icon"></i>
    <span class="shrink label">
      {{ config.label }}
    </span>
    <div class="shrink label">
      @if(config.subMenuItems && config.subMenuItems.length > 0){
        <i class="icon-carat-right arrow-right-icon"></i>
      }
    </div>
    <ng-content></ng-content>
  </div>
  }

</ng-container>
